var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutoutRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 66,
    viewBox: "0 0 32 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.44248e-06 33C-6.45818e-07 14.7746 14.3269 6.26248e-07 32 1.39876e-06L32 66C14.3269 66 -2.23913e-06 51.2254 -1.44248e-06 33Z",
    fill: "#000F06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutoutRight);
export default __webpack_public_path__ + "static/media/CutoutRight.8f779da9d573d7b020910630e8e49e72.svg";
export { ForwardRef as ReactComponent };